/**
 * @description
 * cache keys for react query's cache.
 */
export const cacheKey = {
	myUser: "myUser",
	rates: "rates",
	currentUser: "currentUser",
	walletBalanceAndTokenDetails: "walletBalanceAndTokenDetails",
	tokenReportSummary: "tokenReportSummary",
	transactionHistory: "transactionHistory",
	accessRequests: "accessRequests",
	accessRequestStats: "accessRequestStats",
	dashboardTransactionHistory: "dashboardTransactionHistory",
	institutionWallets: "institutionWallets",
	currentUserRole: "currentUserRole",
	featureFlags: "featureFlags",
	cbTransactionsHistory: "cbTransactionsHistory",
	transactionSummary: "transactionSummary",
	walletGraphData: "walletGraphData",
	tokens: "tokens",
	walletSummary: "walletSummary",
  // Tasks
  accessRequestTasks: "accessRequestTasks",
  accessRequestTaskHistory: "accessRequestTaskHistory",
  accessRequestComments: "accessRequestComments"
};
